import { app } from '@/vendors/firebase/firebase';
import axios from 'axios';
import HistoryTransformer from './HistoryTransformer';

export default {
  async list(shopId) {
    const res = [];
    const snapshot = await app.firestore()
      .collection('histories')
      .where('shop', '==', shopId)
      .get();
    snapshot.forEach((doc) => {
      res.push(HistoryTransformer.transformOne(doc.data()));
    });
    return HistoryTransformer.transformList(res);
  },

  async putHistory(history) {
    let docId;
    await app.firestore()
      .collection('histories')
      .add(history)
      .then((docRef) => {
        docId = docRef.id;
      });
    return docId;
  },

  async getLatestHistory(shopId) {
    const res = [];
    const snapshot = await app.firestore()
      .collection('histories')
      .where('shop', '==', shopId)
      .orderBy('time', 'desc')
      .limit(1)
      .get();

    snapshot.forEach((doc) => {
      res.push(HistoryTransformer.transformOne(doc.data()));
    });
    return HistoryTransformer.transformList(res);
  },


  async getLatestHistoryBySupplier(shopId, supplier) {
    const res = [];
    const snapshot = await app.firestore()
      .collection('histories')
      .where('shop', '==', shopId)
      .where('supplier', '==', supplier)
      .orderBy('time', 'desc')
      .limit(1)
      .get();

    snapshot.forEach((doc) => {
      res.push(HistoryTransformer.transformOne(doc.data()));
    });
    return HistoryTransformer.transformList(res);
  },

  historyFromCart(cart, shopId, user, priceHt, supplier, id, orderType) {
    return {
      cartOrder: { ...cart },
      shop: shopId,
      user,
      time: Date.now(),
      priceHt,
      supplier,
      id,
      orderType,
    };
  },
  updateHistoryStatus(cmdId, status) {
    const options = {
      headers: {
        Authorization: process.env.VUE_APP_MARKETPLACE_BACKEND_API_KEY,
      },
    };
    return axios.post(
      `${process.env.VUE_APP_MARKETPLACE_BACKEND_URL}/pendingOrdersUpdate`,
      {
        id: cmdId,
        event: status,
      }, options,
    );
  },

  lastHistoryEvent(eventList) {
    if (eventList && eventList.length) {
      return eventList;
    }
    return 'Pas de statut disponible';
  },
};
